import { useEffect } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import { ProgressBar, Title, SubTitle } from './components'
import FooterButton from 'components/modules/common/FooterButton'
import star from 'images/star_dimmed.png'
import gift from 'images/gift_dimmed.png'
import writinghand from 'images/writinghand_dimmed.png'
import calendar from 'images/calendar_dimmed.png'
import expert from 'images/expert_dimmed.png'
import routine from 'images/routine_dimmed.png'

const OnboardingStep1A = () => {
  const history = useHistory()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <ProgressBarWrapper>
        <ProgressBar currentStep={1} />
      </ProgressBarWrapper>

      <TitleWrapper>
        <Title>
          일단 시작할 수 있도록
          <br />이 모든 혜택을 무료로 지원해요!
        </Title>
        <SubTitle>돈걱정 없이 일단 시작해봐요!</SubTitle>
      </TitleWrapper>

      <Content>
        <BenefitList>
          <Benefit color={'#8F8B8B'}>
            <Emoticon src={star} alt={'별'} length={24} />
            챌린지 무료 참여
          </Benefit>
          <Benefit color={'#A0A0A0'}>
            <Emoticon src={gift} alt={'선물상자'} length={25} />
            상금 챌린지 무료 참여
          </Benefit>
          <Benefit color={'#AFAFAF'}>
            <Emoticon src={writinghand} alt={'글쓰는손'} length={28} />
            무제한 습관 기록 가능
          </Benefit>
          <Benefit color={'#BDBDBD'}>
            <Emoticon src={calendar} alt={'달력'} length={25} />
            한눈에 보는 습관 캘린더
          </Benefit>
          <Benefit color={'#CECECE'}>
            <Emoticon src={expert} alt={'전문가'} length={28} />
            전문가 건강 콘텐츠
          </Benefit>
          <Benefit color={'#DFDFDF'}>
            <Emoticon src={routine} alt={'루틴'} length={25} />
            나만의 루틴 생성
          </Benefit>
        </BenefitList>

        <Dots>
          <Dot color={'#DFDFDF'} />
          <Dot color={'#EAEAEA'} />
          <Dot color={'#F1F1F1'} />
        </Dots>
      </Content>

      <FooterButton isValid={true} onComplete={() => history.push('/onboarding/step2')}>
        좋아! 한번 시작해 볼래!
      </FooterButton>
    </Container>
  )
}

const Container = styled.div`
  padding: 24px 20px 36px;
  position: relative;
  height: 100vh;
`

const ProgressBarWrapper = styled.div`
  margin-bottom: 36px;
`

const TitleWrapper = styled.div`
  margin-bottom: 54px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const BenefitList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`

const Benefit = styled.div`
  font-size: calc(100vw * (24 / 375));
  font-weight: 600;
  line-height: calc(100vw * (35 / 375));
  color: ${({ color }) => color};
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  left: calc(100vw * (-8 / 375));

  :not(:last-child) {
    margin-bottom: 25px;
  }
`

const Emoticon = styled.img`
  width: calc(100vw * (${({ length }) => length} / 375));
  height: calc(100vw * (${({ length }) => length} / 375));
  margin-right: calc(100vw * (6 / 375));
`

const Dots = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Dot = styled.div`
  width: calc(100vw * (6 / 375));
  height: calc(100vw * (6 / 375));
  border-radius: 50%;
  background-color: ${({ color }) => color};

  :not(:last-child) {
    margin-bottom: 4px;
  }
`

export default OnboardingStep1A
